import React from 'react';

/**
 * WhiteLogo
 * Renders any partner/sponsor logo as a pure, crisp white logo on dark backgrounds.
 * 
 * - Børnecancerfonden: Uses image https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/b95b4ebb46037cd2c7954e66fca28753805e9de7.png
 * - Foliekniven: Uses image https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/70ead0529c569de20a4c99ace86c114842c11be0.png
 */
export default function WhiteLogo({ src, alt, className = '' }) {
  if (!src) return null;

  // 1. Børnecancerfonden
  if (src.includes('b95b4ebb') || (alt && alt.toLowerCase().includes('børnecancerfonden'))) {
    const boernecancerfondenLogo = 'https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/b95b4ebb46037cd2c7954e66fca28753805e9de7.png';
    return (
      <img
        src={boernecancerfondenLogo}
        alt={alt || "Børnecancerfonden"}
        className={className}
        style={{
          mixBlendMode: 'screen',
          filter: 'drop-shadow(0 2px 14px rgba(255,255,255,0.3))',
        }}
        loading="lazy"
      />
    );
  }

  // 2. Foliekniven.dk
  if (src.includes('70ead052') || (alt && alt.toLowerCase().includes('foliekniven'))) {
    const folieknivenLogo = 'https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/70ead0529c569de20a4c99ace86c114842c11be0.png';
    return (
      <img
        src={folieknivenLogo}
        alt={alt || "Foliekniven.dk"}
        className={className}
        style={{
          mixBlendMode: 'screen',
          filter: 'drop-shadow(0 2px 14px rgba(255,255,255,0.3))',
        }}
        loading="lazy"
      />
    );
  }

  // 3. Logos with solid black background (SH Group, Marius Pedersen, M. Transport):
  const isBlackBgLogo =
    src.includes('1f2c14af') || // SH Group
    src.includes('d9f07c30') || // Marius Pedersen
    src.includes('56fa6146');   // M. Transport

  if (isBlackBgLogo) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          mixBlendMode: 'screen',
          filter: 'brightness(1.3) contrast(1.1) drop-shadow(0 2px 14px rgba(255,255,255,0.2))',
        }}
        loading="lazy"
      />
    );
  }

  // 4. Standard transparent logos (Broby IF, Børnelungefonden, allresq.nu, JKR, AEH):
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        filter: 'brightness(0) invert(1) drop-shadow(0 2px 14px rgba(255,255,255,0.2))',
      }}
      loading="lazy"
    />
  );
}
